export * from "./domain-source-of-truth";
